import { render } from "./DialogOptionTabs.vue?vue&type=template&id=5b2e56dc&scoped=true"
import script from "./DialogOptionTabs.vue?vue&type=script&lang=js"
export * from "./DialogOptionTabs.vue?vue&type=script&lang=js"

import "./DialogOptionTabs.vue?vue&type=style&index=0&id=5b2e56dc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b2e56dc"]])

export default __exports__